module.exports = __webpack_public_path__ + "img/jzts2.97fd2b67.png";